import * as React from 'react';

export const  Git =()=> (
<svg version="1.1" viewBox="0 0 600 600" xmlns="http://www.w3.org/2000/svg">
 <path d="m540 278-218-218a32 32 0 0 0-46 0l-45 45 58 57a38 38 0 0 1 48 49l55 55a38 38 0 1 1-23 22l-52-52v136a38 38 0 1 1-31-1v-137a38 38 0 0 1-21-50l-57-57-150 150a32 32 0 0 0 0 45l218 218a32 32 0 0 0 46 0l217-217a32 32 0 0 0 0-45" fill="#f05133"/>
</svg>
)